<template>
  <div class="modal__header">
    <div class="modal__header-inner">
      <h2>{{ title }}</h2>

      <div class="modal__header-actions">
        <slot name="actions" />

        <Button
          v-if="showClose"
          icon="pi pi-times"
          severity="secondary"
          size="large"
          autofocus
          text
          rounded
          @click="close(false)" />
      </div>
    </div>

    <div v-if="$slots.default" class="modal__header-footer">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string;
    showClose?: boolean;
  }>(),
  {
    showClose: true
  }
);

const $modal = inject('$modal', {
  close: (...args: any) => args
});

const close = (...args: any) => $modal.close(...args);
</script>

<style lang="postcss">
.modal {
  &__header {
    @apply relative z-[1] bg-white;

    box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.08);

    &-inner {
      @apply flex items-center justify-between gap-3 py-5 pl-8 pr-5;
    }

    &-actions {
      @apply flex items-center justify-between gap-3;
    }

    &-footer {
      @apply pl-8 pr-5;
    }
  }
}
</style>
